import React, { Component } from 'react';
import './Contacts.css';
import { Parallax } from 'react-scroll-parallax';

class Contacts extends Component {
  render() {
    return (
    	<div className="cont">
        <div className="manager">
          <h2 className="h2-responsive">Manažer</h2>
          <h1 className="h1-responsive font-weight-bold">Martin Drančák</h1>
          <h4 className="h4-responsive">drancak@sutb.cz</h4>
          <h4 className="h4-responsive">+420 777 422 479</h4>
        </div>

  <div class="d-flex justify-content-between flex-wrap">
    <div class="p-2">
      <h2 className="h2-responsive">Kapely & Line up</h2>
      <h1 className="h1-responsive font-weight-bold">Barbora Mikolášová</h1>
      <h4 className="h4-responsive">mikolasova@sutb.cz</h4>
    </div>
    <div class="p-2">
      <h2 className="h2-responsive">Fundraising</h2>
      <h1 className="h1-responsive font-weight-bold">Adam Utíkal</h1>
      <h4 className="h4-responsive">utikal@sutb.cz</h4>
    </div>
  </div>
  <div class="d-flex justify-content-between flex-wrap">
    <div class="p-2">
      <h2 className="h2-responsive">Technika</h2>
      <h1 className="h1-responsive font-weight-bold">Radek Musil</h1>
      <h4 className="h4-responsive">musil@sutb.cz</h4>
    </div>
    <div class="p-2">
      <h2 className="h2-responsive">Grafika & Propagace</h2>
      <h1 className="h1-responsive font-weight-bold">Adam Komůrka</h1>
      <h4 className="h4-responsive">komurka@sutb.cz</h4>
    </div>
  </div>
		  </div>
    );
  }
}

export default Contacts;